import { cqrs } from '@faro/http-clients';
import { StageGroup, toStageGroup } from '@faro/study-designer-model';
import { StudyPathParameter } from '../parameter';

export interface StageGroupQueryParameter {
    readonly schemaId?: string;
}

export type StageGroupPathParameters = StudyPathParameter;
export type StageGroupQueryParameters = StageGroupQueryParameter;

/**
 * Client responsible for accessing the backend entity services
 */
export const stageGroupClient = cqrs<StageGroup, StageGroupPathParameters>(
    '/api/study-designer/studies/:studyId/stage-groups',
    toStageGroup
).listableEntityClient<StageGroupQueryParameters>();
